module.exports = __webpack_public_path__ + "img/def-banner-1.03225f24.jpg";